<template>
    <div id="building">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-home-group</v-icon> Building Preferences
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.buildingOption01" readonly hide-details
                            label="Building Preference - First Choice" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.buildingOption02" readonly hide-details
                            label="Building Preference - Second Choice" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.buildingUnitPreference" readonly hide-details
                            label="Unit Preference" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.residenceMealPlan" readonly label="Meal Plan"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.healthDietaryConcern" auto-grow readonly hide-details
                            label="Health/Dietary Concern(s)" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="font-weight-medium px-0">
                            {{ item.buildingOption01 || 'Building Preference - First Choice' }} -
                            Roommate
                            Requests
                        </v-card-subtitle>
                        <v-alert v-if="item.roommateRequest01 && item.roommateRequest01.length == 0" :color="infoColor"
                            dense icon="mdi-information" text>
                            There are no roommate requests for the first building preference choice or the building may
                            not allow roommate requests.</v-alert>
                        <v-text-field v-for="(roommate, i) in item.roommateRequest01" :key="i" readonly hide-details
                            :label="'Roommate Name #' + (i + 1)" :value="roommate">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="font-weight-medium px-0">
                            {{ item.buildingOption02 || 'Building Preference - Second Choice' }} -
                            Roommate
                            Requests
                        </v-card-subtitle>
                        <v-alert v-if="item.roommateRequest02 && item.roommateRequest02.length == 0" :color="infoColor"
                            dense icon="mdi-information" text>
                            There are no roommate requests for the second building preference choice or the building may
                            not allow roommate requests.</v-alert>
                        <v-text-field v-for="(roommate, i) in item.roommateRequest02" :key="i" readonly hide-details
                            :label="'Roommate Name #' + (i + 1)" :value="roommate">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.residencePrevious" readonly hide-details
                            label="Previous residence experience" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col v-if="item.residencePrevious == 'Yes'" cols="12">
                        <v-text-field v-model="item.residencePreviousLocation" readonly hide-details
                            label="Previous residence location" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-building-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>